// =====================================================
// 📁 components/QuotationViewHeader.tsx
// =====================================================

import React from 'react';
import { formatDateOnly, formatFriendlyDateTime } from '../../../../../../utils/dateFormatters';

interface Props {
  quotation: any;
}

const QuotationViewHeader: React.FC<Props> = ({ quotation }) => {
  return (
    <div
      className="
        rounded-sm border border-stroke
        bg-white shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* Header */}
      <div
        className="
          border-b border-stroke
          px-5 py-4
          dark:border-strokedark
          sm:px-6
        "
      >
        <div
          className="
            flex flex-col gap-4
            lg:flex-row
            lg:items-center
            lg:justify-between
          "
        >
          {/* Left */}
          <div>
            <h2
              className="
                text-2xl font-bold
                text-black
                dark:text-white
              "
            >
              {quotation.quotationNumber}
            </h2>

            <div className="mt-3">
              <span
                className="
                  inline-flex rounded-sm
                  bg-primary
                  px-3 py-1
                  text-sm font-medium
                  text-white
                "
              >
                {quotation.status}
              </span>
            </div>
          </div>

          {/* Right */}
          <div
            className="
              grid grid-cols-1 gap-4
              text-sm
              sm:grid-cols-2
            "
          >
            {/* Fecha Cotización */}
            <div>
              <p
                className="
                  mb-1 text-bodydark2
                "
              >
                Fecha Cotización
              </p>

              <p
                className="
                  font-medium text-black
                  dark:text-white
                "
              >
                {formatFriendlyDateTime(quotation.quotationDate)}
              </p>
            </div>

            {/* Fecha Vencimiento */}
            <div>
              <p
                className="
                  mb-1 text-bodydark2
                "
              >
                Fecha Vencimiento
              </p>

              <p
                className="
                  font-medium text-black
                  dark:text-white
                "
              >
                {formatDateOnly(quotation.expirationDate)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationViewHeader;
